(() => {
  const ROOT_SELECTOR = '[data-iconic-set-upsell]';

  const normalize = (value) =>
    String(value || '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

  const parseJson = (el) => {
    if (!el) return null;

    try {
      return JSON.parse(el.textContent);
    } catch (error) {
      console.warn('[ICONIC set upsell] JSON parse error:', error);
      return null;
    }
  };

  const initSetUpsell = (root) => {
    const sourceData = parseJson(root.querySelector('[data-source-product-json]'));
    const setData = parseJson(root.querySelector('[data-set-product-json]'));

    if (!sourceData || !setData) return;

    const sourceIndex = Number(root.dataset.sourceOptionIndex || 0);
    const targetIndex = Number(root.dataset.targetOptionIndex || 0);
    const ctaTemplate = root.dataset.ctaTemplate || '3er Set in {color} ansehen';
    const mediaAltPrefix = root.dataset.mediaAltPrefix || 'set-upsell';
    const hideWhenNoMatch = root.dataset.hideWhenNoMatch === 'true';

    const cta = root.querySelector('[data-set-cta]');
    const ctaLabel = root.querySelector('[data-set-cta-label]');
    const imageLink = root.querySelector('[data-set-image-link]');
    const image = root.querySelector('.iconic-set-upsell__img');

    const productInfo = root.closest('product-info') || document;
    const form =
      productInfo.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]');

    const getVariantInput = () =>
      form ? form.querySelector('[name="id"]') : document.querySelector('form[action*="/cart/add"] [name="id"]');

    const getCurrentVariantId = () => {
      const input = getVariantInput();
      const inputValue = input && input.value ? Number(input.value) : null;
      const urlValue = Number(new URLSearchParams(window.location.search).get('variant'));

      return inputValue || urlValue || Number(sourceData.selectedVariantId);
    };

    const getCurrentVariant = () => {
      const id = getCurrentVariantId();
      return (sourceData.variants || []).find((variant) => Number(variant.id) === Number(id));
    };

    const getCurrentColor = () => {
      const variant = getCurrentVariant();

      if (!variant || !Array.isArray(variant.options)) return '';

      return variant.options[sourceIndex] || '';
    };

    const matchSetVariant = (color) => {
      const wanted = normalize(color);
      const variants = setData.variants || [];

      if (!wanted) return null;

      const byTargetOption = (variant) =>
        variant.options && normalize(variant.options[targetIndex]) === wanted;

      const byAnyOption = (variant) =>
        variant.options && variant.options.some((option) => normalize(option) === wanted);

      return (
        variants.find((variant) => variant.available && byTargetOption(variant)) ||
        variants.find((variant) => byTargetOption(variant)) ||
        variants.find((variant) => variant.available && byAnyOption(variant)) ||
        variants.find((variant) => byAnyOption(variant)) ||
        null
      );
    };

    const fallbackSetVariant = () =>
      (setData.variants || []).find((variant) => variant.available) ||
      (setData.variants || [])[0] ||
      null;

    const mediaByAlt = (color) => {
      const wanted = normalize(color);
      const prefix = normalize(mediaAltPrefix);

      if (!wanted) return null;

      const media = setData.media || [];

      const prefixedMatch = media.find((item) => {
        const alt = normalize(item.alt || '');
        return alt.includes(prefix) && alt.includes(wanted);
      });

      if (prefixedMatch) return prefixedMatch.src;

      const colorOnlyMatch = media.find((item) => normalize(item.alt || '').includes(wanted));

      return colorOnlyMatch ? colorOnlyMatch.src : null;
    };

    const imageFor = (color, setVariant) =>
      (setVariant && setVariant.image) ||
      mediaByAlt(color) ||
      setData.fallbackImage ||
      null;

    const update = () => {
      const currentColor = getCurrentColor();
      const matchedVariant = matchSetVariant(currentColor);

      if (!matchedVariant && hideWhenNoMatch) {
        root.hidden = true;
        return;
      }

      root.hidden = false;

      const setVariant = matchedVariant || fallbackSetVariant();
      const targetUrl = setVariant ? setVariant.url : setData.productUrl;
      const targetImage = imageFor(currentColor, setVariant);
      const ctaText = ctaTemplate.replace(/\{color\}/g, currentColor || '');

      if (cta) {
        cta.href = targetUrl;
        cta.setAttribute('aria-label', ctaText);
      }

      if (ctaLabel) {
        ctaLabel.textContent = ctaText;
      }

      if (imageLink) {
        imageLink.href = targetUrl;
        imageLink.setAttribute('aria-label', ctaText);
      }

      if (image && targetImage && image.src !== targetImage) {
        image.src = targetImage;
        image.removeAttribute('srcset');
        image.alt = currentColor ? `3er Set in ${currentColor}` : '3er Set';
      }
    };

    update();

    if (form) {
      form.addEventListener('change', () => window.setTimeout(update, 0));
      form.addEventListener('input', () => window.setTimeout(update, 0));
      form.addEventListener('click', () => window.setTimeout(update, 0));
    }

    document.addEventListener('variant:change', update);
    document.addEventListener('shopify:section:load', update);

    let lastVariantId = getCurrentVariantId();

    window.setInterval(() => {
      const currentVariantId = getCurrentVariantId();

      if (currentVariantId !== lastVariantId) {
        lastVariantId = currentVariantId;
        update();
      }
    }, 350);
  };

  const initAll = () => {
    document.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
      if (root.dataset.iconicSetUpsellInitialized === 'true') return;

      root.dataset.iconicSetUpsellInitialized = 'true';
      initSetUpsell(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
